import { useState } from 'react';
import { Profile } from '#types/account';
import {
  ProfileViewerWrap,
  ImageList,
  ImageItem,
  IndexIconArea,
  IndexIcon
} from './styles';
import { PageIndicator } from '#templates/CoachDetailContent/ProfileViewer/styles';
import { Link } from 'react-router-dom';

interface Props {
  profileImgs: Profile[];
}

export const ProfileImgUploader = ({ profileImgs }: Props) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const handleScroll: React.UIEventHandler<HTMLUListElement> = e => {
    const newIndex = Math.round(
      e.currentTarget.scrollLeft / e.currentTarget.clientWidth
    );
    setCurrentIndex(newIndex);
  };

  return (
    <ProfileViewerWrap>
      <ImageList onScroll={handleScroll}>
        {profileImgs.length > 0 &&
          profileImgs.map(img => (
            <ImageItem key={img.id}>
              <img src={img.resizedLink} />
            </ImageItem>
          ))}
      </ImageList>

      <PageIndicator>
        <Link to="profile-edit">프로필 사진 편집</Link>
      </PageIndicator>
      <IndexIconArea>
        {new Array(profileImgs.length).fill(null).map((_, index) => (
          <IndexIcon
            key={index}
            className={index === currentIndex ? 'point' : ''}
          />
        ))}
      </IndexIconArea>
    </ProfileViewerWrap>
  );
};
